module.exports = __webpack_public_path__ + "static/media/ENTRANCE-FINAL-Model-1.685dac52.webp";